/**
 * PDF操作ユーティリティ
 * PDF生成・表示に関する共通処理を提供する
 */

/**
 * BlobからURLを作成し、新しいタブでPDFを開く
 * @param pdfBlob - PDFのBlobデータ
 */
export const openPdfInNewTab = (pdfBlob: Blob): void => {
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, '_blank');
};

/**
 * PDF APIを呼び出して新しいタブで開く（GET用）
 * @param apiGetPdfFn - PDF取得API関数
 * @param endpoint - APIエンドポイント
 * @param iraiId - 依頼ID
 * @param accessToken - 認証トークン
 * @returns Promise<void>
 */
export const fetchAndOpenPdfById = async (
  apiGetPdfFn: (endpoint: string, iraiId: string, accessToken?: string) => Promise<Blob>,
  endpoint: string,
  iraiId: string,
  accessToken?: string
): Promise<void> => {
  const pdfBlob = await apiGetPdfFn(endpoint, iraiId, accessToken);
  openPdfInNewTab(pdfBlob);
};

/**
 * PDF APIを呼び出して新しいタブで開く（POST用）
 * @param apiPostPdfFn - PDF生成API関数
 * @param endpoint - APIエンドポイント
 * @param data - POSTデータ
 * @param accessToken - 認証トークン
 * @returns Promise<void>
 */
export const generateAndOpenPdf = async <T>(
  apiPostPdfFn: (endpoint: string, body: T, accessToken?: string, customHeaders?: Record<string, string>, additionalParams?: Record<string, string>) => Promise<Blob>,
  endpoint: string,
  data: T,
  accessToken?: string,
  additionalParams?: Record<string, string>
): Promise<void> => {
  const pdfBlob = await apiPostPdfFn(endpoint, data, accessToken, undefined, additionalParams);
  openPdfInNewTab(pdfBlob);
};
